import React    from 'react'
import Layers   from './Layers'
import Venues   from './Venues'
import Bezirk   from './Bezirk'
import MapTheme from './MapTheme'


class Navigation extends React.Component {

  setLayers = (dataFromChild) => {
    this.props.setLayers(dataFromChild);
  }

  setVenues = (dataFromChild) => {

    this.props.setVenues(dataFromChild);
  }
  setBezirk = (dataFromChild) => {
    this.props.setBezirk(dataFromChild);
  }
   
  setMapTheme = (dataFromChild) => {
    this.props.setMapTheme(dataFromChild);
  }


  render() {
    return (
      <div>
        <div className="side-navigation">
          <div className="nav-item" onClick={this.props.toggleVenues}>
            <img src="/venues.svg" alt="Venues icon"/>
          </div>
          <div className="nav-item" onClick={this.props.toggleLayers}>
            <img src="/layers.svg" alt="Layers icon"/>
          </div>
          <div className="nav-item" onClick={this.props.toggleBezirk}>
            <img src="/bezirk.svg" alt="Bezirk icon"/>
          </div>
          <div className="nav-item" onClick={this.props.toggleMapTheme}>
            <img src="/map.svg" alt="Map icon"/>
          </div>
          <div className="nav-item">
            <img src="/info.svg" alt="Info icon"/>
          </div>
        </div>

        <div className={this.props.visibility + " layers"}>
          <Layers setLayers={this.setLayers} />
        </div>

        <div className={this.props.venuesVisibility + " venues"}>
          <Venues setVenues={this.setVenues} 
                  dataFromParent={this.props.dataFromParent} />
        </div>
        <div className={this.props.bezirkVisibility + " bezirk"}>
          <Bezirk setBezirk={this.setBezirk} />
        </div>

        <div className={this.props.mapThemeVisibility + " map-themes"}>
          <MapTheme setMapTheme={this.setMapTheme} />
        </div>

      </div>
    );
  }

}

export default Navigation
